import { defineStore } from "pinia";
import { Mat, MultiFieldValidationErrors } from "../Common/types";
import matsApi, { CreateMatRequest, UpdateMatRequest } from "../Api/mats";
import { handleError } from "../Common/errorHandler";

export const useMatsStore = defineStore("mats", {
    state: () => ({
        mats: [] as Mat[],
        isLoading: false,
        eventId: 0,
        validationErrors: {} as MultiFieldValidationErrors,
        editOrderMode: false,
    }),

    getters: {
        hasMats(): boolean {
            return this.mats.length > 0;
        },
        changingOrderPossible: state => state.mats.length > 1,
    },

    actions: {
        clearValidationErrors() {
            this.validationErrors = {};
        },

        fetchMats() {
            this.isLoading = true;
            return matsApi
                .getMatsListing(this.eventId)
                .then(mats => {
                    this.mats = mats;
                })
                .catch(handleError)
                .finally(() => {
                    this.isLoading = false;
                });
        },

        createMat(request: CreateMatRequest) {
            this.isLoading = true;
            this.clearValidationErrors();

            return matsApi
                .createMat(request)
                .then(() => {
                    return this.fetchMats();
                })
                .catch(handleError)
                .finally(() => {
                    this.isLoading = false;
                });
        },

        updateMat(request: UpdateMatRequest) {
            this.isLoading = true;
            this.clearValidationErrors();

            return matsApi
                .updateMat(request)
                .then(() => {
                    return this.fetchMats();
                })
                .catch(handleError)
                .finally(() => {
                    this.isLoading = false;
                });
        },

        deleteMat(matId: number) {
            this.isLoading = true;
            return matsApi
                .deleteMat(this.eventId, matId)
                .then(() => {
                    this.mats = this.mats.filter(m => m.id !== matId);
                })
                .catch(handleError)
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
});
